import { IAction } from "coral-utility";
import { connectActionTypes, AuthenticatedSuccessPayload } from "./types";
import { User } from "types";

export const authenticatedSuccessAction = (
  user: User
): AuthenticatedSuccessPayload => ({
  type: connectActionTypes.USER_AUTHENTICATION_SUCCESS,
  payload: { user },
});

export const authenticatedFailureAction = (): IAction => ({
  type: connectActionTypes.USER_AUTHENTICATION_FAILURE,
});

export const toggleTheme = (): IAction => ({
  type: connectActionTypes.TOGGLE_THEME,
});

export const userLogOutAction = (): IAction => ({
  type: connectActionTypes.USER_LOGOUT_STARTED,
});

export const logoutSuccessAction = (): IAction => ({
  type: connectActionTypes.USER_LOGOUT_SUCCESS,
});
